export default {
	title: "Delivery",
	subtitle: "Select the municipalities where you deliver your products.",
    defaultPrice: "Default price",
    modal: {
	  title: "Set delivery price",
      close: "Close",
      confirm: "Confirm"
    },
	municipalities: {
		title: "Municipalities",
		placeholder: "Choose one or more municipalities",
		button: "Add",
	},
	table: {
        municipality: "Municipality",
        price: "Delivery Price",
        minimalValue: "Minimal Delivery Price",
        active: "Active",
	},
	notDelivering: "You are not currently delivering in any city.",
};
